<template>
  <div style="height: 100vh;overflow: scroll; padding: 10px;" class="Kanit">
  <br/>
  <br/>
 <div v-if="detailAED.message == 'success'">

   <v-carousel
      cycle
      height="200"
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item
        v-for="(slide, i) in detailAED.data.list_picture"
        :key="i"
      >
        <img :src="API_BACKEND + '/v1' + slide.picture_path" height="200">
      </v-carousel-item>
    </v-carousel>
<v-layout row wrap style="padding: 10px; margin-top: 5px;"> 

      <v-flex xs12 sm12 md12 lg12 xl12>
        <h2>{{detailAED.data.address_name}}</h2>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 >
        <div style="text-align: left; background: #e2e2e2 !important; border-radius: 6px;padding: 10px; margin-bottom: 10px;">
          <span>{{detailAED.data.address_detail}}</span>
        </div>
      </v-flex>

      <v-flex xs3 sm3 md3 lg3 xl3>
        <b>ตำแหน่ง</b>
      </v-flex>
      <v-flex xs9 sm9 md9 lg9 xl9>
        <p>lat: {{detailAED.data.location.latitude}} , lon: {{detailAED.data.location.longitude}}</p>
      </v-flex>

      <v-flex xs3 sm3 md3 lg3 xl3>
        <b>วัน เวลาเปิด-ปิด</b>
      </v-flex>
      <v-flex xs9 sm9 md9 lg9 xl9>
        <p>{{checkOpentime(detailAED.data.opening_time)}} เวลา {{detailAED.data.opening_time.open_time}}-{{detailAED.data.opening_time.close_time}}</p>
      </v-flex>

      <v-flex xs3 sm3 md3 lg3 xl3>
        <b>วันหมดอายุ Pad</b>
      </v-flex>
      <v-flex xs9 sm9 md9 lg9 xl9>
        <p>{{(detailAED.data.pad_expire !=null && detailAED.data.pad_expire != '')? detailAED.data.pad_expire: '-'}}</p>
      </v-flex>

      <v-flex xs3 sm3 md3 lg3 xl3>
        <b>วันหมดอายุแบตเตอร์รี่</b>
      </v-flex>
      <v-flex xs9 sm9 md9 lg9 xl9>
        <p>{{(detailAED.data.battery_expire !=null && detailAED.data.battery_expire != '')? detailAED.data.battery_expire: '-'}}</p>
      </v-flex>
    </v-layout>

  
 </div>
 <div v-else>
  <v-layout align-center justify-center row>
    <img :src="BASE_URL + '/static/img/pagedefault/notfound.jpg'" width="400" >
  </v-layout>

  <h1>ขออภัย ไม่พบข้อมูลเครื่อง AED</h1>
  </div>
  <br/>
  <br/>
  <div style="text-align: center;">
  <a href="https://play.google.com/store/apps/details?id=com.gov.red.aed" target="_blank">
    <img style="width: 200px;" :src="BASE_URL + '/static/img/download/googleplay.png'">
  </a><a href="https://itunes.apple.com/th/app/onechat/id1394435274?mt=8" target="_blank">
    <img style="width: 200px;" :src="BASE_URL + '/static/img/download/appstore.png'">
  </a>
</div>

    
  </div>
</template>

<script>
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
Vue.component(VueQrcode.name, VueQrcode)
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      API_FRONTEND: process.env.API_FRONTEND,
      detailAED: '',
      API_BACKEND: process.env.API_BACKEND
    }
  },
  created () {
    if (this.$route.params.id != '' && this.$route.params.id != null) {
      this.getDetailQRcode()
      window.location.replace('aed://com.gov.red.aed/qrcode?id=' + this.$route.params.id)
    }
  },
  watch: {
  },
  methods: {
    checkOpentime (opening_time) {
      if (opening_time.open_type == 'someday'){
        var toggle = false;
        var listDay = []
        var item = 0
        for (item in opening_time.open_day) {
          listDay.push(this.dayOfWeekAsInteger(opening_time.open_day[item]))
        }
        listDay.sort()
        var display = ''

        for (var i=0; i <= listDay.length ; i++){
          if (i == 0) {
            display = '' + listDay[0]
          } else if (i == listDay.length-1) {
            if (listDay[i-1] == listDay[i]-1) {
              display = display + "-" + listDay[i]
            } else {
              display = display + "," + listDay[i]
            }
          } else if (i == listDay.length) {
            return this.thaiday(display)
          } else if (listDay[i-1] == listDay[i]-1){
          } else if (i == 1) {
            display = display + "," + listDay[i]

          } else {
            display = display + "-" + listDay[i-1] + "," + listDay[i]
          }
        }
      } else {
        return 'ทุกวัน'
      }
    },
    thaiday (day) {
      return day.replace('1', 'วันจันทร์').replace('2', 'วันอังคาร').replace('3', 'วันพุธ').replace('4', 'วันพฤหัสบดี').replace('5', 'วันศุกร์').replace('6', 'วันเสาร์').replace('7', 'วันอาทิตย์')
    },
    dayOfWeekAsInteger(day) {
      return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].indexOf(day) + 1
    },
    getDetailQRcode () {
      var body = {
        qrcode_id: this.$route.params.id
      }
      this.$api.getAEDDetailByQrCodeID(body).then((response) => {
        this.detailAED = response.data
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.horizontal-center {
  margin-left: auto;
  margin-right: auto;
}
/*>>>.theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
    border: #aa0800ff 2px solid;
}*/
/*>>>.theme--light.v-label {
    color: black !important;
}*/
/*>>>.theme--light.v-select .v-select__selections {
    color: rgb(168, 13, 0) !important;
}*/
.pd-10 {
  padding: 10px !important;
}
.toolbarqrcode {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/QRcodeRedirect.vue